import { Component, Input } from '@angular/core';

@Component({
  selector: 'data-card',
  templateUrl: './data-card.component.html',
  styleUrls: ['./data-card.component.scss'],
})
export class DataCardComponent {
  @Input()
  title: string;

  @Input()
  data: number | string;

  @Input()
  color: string;

  @Input()
  isLoading: boolean;

  @Input()
  label: string;

  @Input()
  tooltipData: string;

  @Input()
  tooltipTitle: string;

  @Input()
  iconTitle: string;

  @Input()
  measurement: string;

  @Input()
  hideFooter: boolean;

  @Input()
  isChart: boolean;

  @Input()
  helpTooltip: string;
}

